export default __webpack_public_path__ + "static/media/audio.57da1130.svg";